var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: { hide: _vm.loading },
    },
    [
      _c("cms-heading", { attrs: { title: _vm.pageTitle } }),
      _c(
        "cms-form-panel",
        {
          attrs: {
            "submit-button": "Opslaan",
            "cancel-button": true,
            submitting: _vm.submitting,
          },
          on: { submit: _vm.submit },
        },
        [
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              title: "Serienummer",
              name: "serialNumber",
              "data-vv-as": "Serienummer",
              error: _vm.error("serialNumber"),
            },
            model: {
              value: _vm.pendingLogger.serialNumber,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLogger,
                  "serialNumber",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLogger.serialNumber",
            },
          }),
          _c("cms-form-dropdown", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              title: "Type",
              options: _vm.typeOptions,
              searchable: "true",
              "data-vv-as": "Type",
              error: _vm.error("typeId"),
              "data-vv-name": "typeId",
            },
            model: {
              value: _vm.pendingLogger.typeId,
              callback: function ($$v) {
                _vm.$set(_vm.pendingLogger, "typeId", $$v)
              },
              expression: "pendingLogger.typeId",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              title: "Eigenaar",
              name: "owner",
              "data-vv-as": "Eigenaar",
              error: _vm.error("owner"),
            },
            model: {
              value: _vm.pendingLogger.owner,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLogger,
                  "owner",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLogger.owner",
            },
          }),
          _c("cms-form-date-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              title: "Datum aanschaf",
              name: "purchaseDate",
              input: "true",
              options: { disableMobile: true },
              "data-vv-as": "Datum aanschaf",
              error: _vm.error("purchaseDate"),
            },
            model: {
              value: _vm.pendingLogger.purchaseDate,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLogger,
                  "purchaseDate",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLogger.purchaseDate",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|min_value:0",
                expression: "'required|min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              step: "any",
              min: "0",
              title: "Aanschafwaarde",
              name: "purchaseValue",
              "data-vv-as": "Aanschafwaarde",
              error: _vm.error("purchaseValue"),
            },
            model: {
              value: _vm.pendingLogger.purchaseValue,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLogger,
                  "purchaseValue",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLogger.purchaseValue",
            },
          }),
          _c("cms-form-input", {
            attrs: {
              title: "Document referentienummer",
              name: "documentReference",
            },
            model: {
              value: _vm.pendingLogger.documentReference,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLogger,
                  "documentReference",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLogger.documentReference",
            },
          }),
          _c("cms-form-textarea", {
            attrs: { title: "Opmerkingen", name: "comments" },
            model: {
              value: _vm.pendingLogger.comments,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingLogger,
                  "comments",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingLogger.comments",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }